<!-- 成功开通会员 -->
<template>
  <div class='open_success'>
    <Fontnavbar title="开通成功" />
    <div class="success_logo">
      <img src="../../../public/static/open_success.png" alt="">
    </div>
    <div class="btn" @click="toJump">
        立即去网站挑选产品
    </div>
  </div>
</template>

<script>
import Fontnavbar from "../../components/Navbar.vue";
export default {
  components: {
    
    Fontnavbar,
  },
  data () {
    return {
    };
  },
  computed: {},
  watch: {},
  created () {
  },
  mounted () {

  },
  methods: {
    toJump(){
      this.$router.push('/goods/index')
    }
  },
}
</script>
<style lang='less' scoped>
.open_success {
  .success_logo{
    display: flex;
    justify-content: center;
    padding-top: 20px;
  }
  .btn {
      margin: 30vh auto;
      width: 80%;
      height: 46px;
      line-height: 46px;
      text-align: center;
      color: #5c4822;
      font-size: 16px;
      background: url('../../../public/static/open_vip_bj.png');
      background-size: 100% 100%;
  }
}
</style>